import GameHeaven from "../Resources/Images/game.png";
import FaceAI from "../Resources/Images/face.png";
import MathSprint from "../Resources/Images/math.png";
import Twitter from "../Resources/Images/twitter.png";
import ClothingStore from "../Resources/Images/clothing.png";
import Food from "../Resources/Images/food.png";

export const ProjectsData = [
  {
    ProjectImage: ClothingStore,
    ProjectName: "Clothing Store Website",
    ProjectDescription:
      "Build with React, Redux, Firebase Auth, Firebase Firestore & Stripe Payments. Implemented better state management for future project scaling. Implemented better User Experience through animations, easier navigation through website and Mobile Responsiveness.",
    ProjectSourceCode: "https://github.com/Thisisaarush/Clothing-Store-Website",
    ProjectLiveSite: "https://thisisaarush.github.io/Clothing-Store-Website/",
  },
  {
    ProjectImage: Food,
    ProjectName: "Restaurant Mobile App",
    ProjectDescription:
      "Mobile App built using React Native with Expo. Integrated Maps foreasier findings of user favorite restaurants. Animations for better userexperience. Implemented Searching for locations and fetching allrestaurants for the same.",
    ProjectSourceCode: "https://github.com/Thisisaarush/Food-Delivery-App",
    ProjectLiveSite: "https://expo.dev/@thisisaarush/food-delivery-app",
  },
  {
    ProjectImage: GameHeaven,
    ProjectName: "Gaming Heaven Website",
    ProjectDescription:
      "Get to know about top Upcoming, Trending, and Most Popular Games. This website will auto-update for future game data. Get to know everything about your favorite games coming on any platform. Worked with multiple API requests to get games data and animations for better UX.",
    ProjectSourceCode: "https://github.com/Thisisaarush/GameHeaven",
    ProjectLiveSite: "https://thisisaarush.github.io/GameHeaven/",
  },
  {
    ProjectImage: FaceAI,
    ProjectName: "AI Brain Face Recognition",
    ProjectDescription:
      "Fetched and filtered data from 'FaceRecognition' API from Clarifai.com and build a local server with Node and express and used Postgresql for the database. Used 'bcrypt' for encryption of user passwords while registering for better security.",
    ProjectSourceCode:
      "https://github.com/Thisisaarush/CelebFaceRecognitionAiReactApp",
  },
  {
    ProjectImage: MathSprint,
    ProjectName: "Math Sprint Game",
    ProjectDescription:
      "Users need to choose the no. of questions and solve them as fast as they can because the ranking system is based on time. Test your math skills in the game. Built to sharpen Math Skills with responsive UI.",
    ProjectSourceCode: "https://github.com/Thisisaarush/MathSprintGame",
    ProjectLiveSite: "https://thisisaarush.github.io/MathSprintGame/",
  },
  {
    ProjectImage: Twitter,
    ProjectName: "Twitter Web App",
    ProjectDescription:
      "Made with React, Firebase Auth, styled-components for styling and react twitter widgets. This projects aims at cloning twitter web app as close as possible and improve the user experience even more with smooth animations and responsive design.",
    ProjectSourceCode: "https://github.com/Thisisaarush/twitter-clone",
    ProjectLiveSite: "https://thisisaarush.github.io/twitter-clone/",
  },
];
